import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetTariffs = function (id) {
    return useApiCall(function (signal, id) { return api.tariff.apiTariffDataGetPortfolioTariffsIdGet(id, { signal: signal }); }, [], !!id, [id]);
};
